import React from 'react';
import ReactTooltip from 'react-tooltip';
import Magnifier from 'react-magnifier';
import {bmfConnectImageUrl} from '../../../../../shared/bmfConnectHelper';

class RimCardDetails extends React.Component {

   availabilityHandler(rim) {
      let returnValue = '';
      let chosenItem = this.props.chosenItem;
      if (!chosenItem) {
         if (this.props.rimSize) {
            let i = 0;
            while (i < rim.length) {
               if (rim[i].size == this.props.rimSize) {
                  chosenItem = i;
                  i = rim.length;
               } else {
                  i++
               }
            }
         } else chosenItem = 0;
      }
      if (!rim[chosenItem]) {
         chosenItem = 0;
      }
      if (rim[chosenItem].status == 'NO_STOCK') {
         returnValue = 'availability yellow';
      } else if (rim[chosenItem].status == 'PARTIAL_STOCK') {
         returnValue = 'availability blue';
      } else if (rim[chosenItem].status == 'IN_STOCK') {
         returnValue = 'availability green';
      }
      return returnValue;
   }

   priceHandler(rim) {
      for (let sizes of rim.items) {
         if (sizes.size == this.props.rimSize) {
            return sizes.retailPrice ? sizes.retailPrice : 'Preis auf Anfrage';
         }
      }
      return (rim.items[0].retailPrice ? rim.items[0].retailPrice : 'Preis auf Anfrage'
      );
   }

   render() {
      let {visible, active, rim, rimSize} = this.props;
      let price = this.priceHandler(rim);
      let favRims = this.props.favRims;
      let favRimIds = [];
      if (favRims[this.props.carId] && favRims[this.props.carId][0] && favRims[this.props.carId][0].id) {
         for (let x of favRims[this.props.carId]) {
            favRimIds.push(x.id)
         }
      }

      let retailPriceForFour = undefined;
      // if (price !== 'Preis auf Anfrage') {
      //    retailPriceForFour = price * 4;
      // }

      var formatter = new Intl.NumberFormat('de-DE', {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2,
         style: 'currency',
         currency: 'EUR'
      });
      return (
         <div className={'clickable'}>
            <div className={'row'}>
               <div className={'col ' + this.availabilityHandler(rim.items)}>
                  {this.availabilityHandler(rim.items) === 'availability green' ?
                     <span>sofort verfügbar</span> :
                     this.availabilityHandler(rim.items) === 'availability blue' ?
                        <span>wenige verfügbar</span> :
                        <span>auf Anfrage</span>
                  }
               </div>
               <div className={'col-2 favorite text-right'}
                    onClick={() => this.props.favoriteCallBack(rim)}>
                  <i className={this.props.favRims[this.props.carId] && favRimIds.includes(rim.id) ? 'fas fa-star' : 'far fa-star'}
                     data-tip data-for={'favorite'}/>
                  <ReactTooltip id='favorite' place={'bottom'}>
                     <span>
                        Zu Favoriten hinzufügen/entfernen
                     </span>
                  </ReactTooltip>
               </div>
            </div>
            <div onClick={!this.props.hoverState ? () => this.props.setRim() : console.log()}>
                <div className={'image-wrapper'}>
                   {rim.imageFrontUrl || rim.imagePerspectiveUrl ? '' : (console.log('noimage'))}
                   {!active ?
                      <img className={'img rim-image ' + (active ? 'large' : 'thumbnail')}
                           src={rim.imagePerspectiveUrl ? bmfConnectImageUrl(rim.imagePerspectiveUrl) : (rim.imageFrontUrl ? bmfConnectImageUrl(rim.imageFrontUrl) : '/noimage.png')}/>
                      :
                      <Magnifier style={{'position': 'relative', 'top': 0}}
                                 mgWidth={220} mgHeight={220} mgTouchOffsetX={15} mgTouchOffsetY={0}
                                 zoomFactor={0.9}
                                 src={rim.imagePerspectiveUrl ? bmfConnectImageUrl(rim.imagePerspectiveUrl) : (rim.imageFrontUrl ? bmfConnectImageUrl(rim.imageFrontUrl) : '/noimage.png')}
                                 zoomImgSrc={rim.imagePerspectiveUrl ? bmfConnectImageUrl(rim.imagePerspectiveUrl) : (rim.imageFrontUrl ? bmfConnectImageUrl(rim.imageFrontUrl) : '/noimage.png')}
                                 className={'car-view-image'}
                                 mgShape='square'
                                 mgShowOverflow={true}/>
                   }
                </div>
               <div style={{'visibility': visible && !active ? 'visible' : 'hidden'}}>
                  <div className={'row rim-description'}>
                     <div className={'col-5 text-highlight'}>
                        <h3>{rim.manufacturer}</h3>
                        <div>{rim.name}</div>
                        <div>{rim.colorGroup}</div>
                     </div>
                     <div className={'col-7 text-right pt' + (price == 'Preis auf Anfrage' ? ' poa' : '')}>
                        {
                           price !== 'Preis auf Anfrage' ?
                              <span className={'text-highlight price-span'}>
                                 ab <b className="price">{formatter.format(price)}</b>
                                 {retailPriceForFour ?
                                    <div className="price-for-four">4
                                       Stück <b>{formatter.format(retailPriceForFour)}</b></div>
                                    : ''}
                              </span>
                              :
                              <span className={'text-highlight price-span'}>
                                 {formatter.format(price)}
                              </span>
                        }
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default (RimCardDetails);
